import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home/Home";
import WP from "./pages/wp"; // ✅ استيراد صفحة White Paper
import { useEffect } from "react";
import WOW from "wow.js";
import { useLocation } from "react-router-dom";

function App() {
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/wp" element={<WP />} /> {/* ✅ إضافة المسار */}
      </Routes>
    </>
  );
}

export default App;